import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function TechForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxArray = (key, value) => {
    const current = formState[key] || [];
    const updated = current.includes(value)
      ? current.filter(v => v !== value)
      : [...current, value];
    setFormState(key, updated);
  };

  const handleRadio = (key, value) => {
    setFormState(key, value);
  };

  const platforms = ['Web', 'Mobile', 'Desktop'];
  const pricingModels = ['Subscription', 'One-time', 'Freemium', 'Custom'];

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Shared: WebDev, SaaS, MobileApps */}
      {(subtype === 'TO_webDev' || subtype === 'TO_saas' || subtype === 'TO_mobileApps') && (
        <div className="field">
          <label>Supported Platforms</label>
          <div className="flex flex-column gap-2">
            {platforms.map(platform => (
              <div key={platform} className="flex align-items-center">
                <Checkbox
                  inputId={`platform-${platform}_${subtype}`}
                  checked={formState[`supportedPlatforms_${subtype}`]?.includes(platform) || false}
                  onChange={() => handleCheckboxArray(`supportedPlatforms_${subtype}`, platform)}
                />
                <label htmlFor={`platform-${platform}_${subtype}`} className="ml-2">{platform}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Shared: WebDev, MobileApps, IT Services */}
      {(subtype === 'TO_webDev' || subtype === 'TO_mobileApps' || subtype === 'TO_itServices') && (
        <div className="field">
          <label>Tech Stack</label>
          <InputText
            value={formState[`techStack_${subtype}`] || ''}
            onChange={(e) => setFormState(`techStack_${subtype}`, e.target.value)}
            placeholder="e.g. React, Node.js, Python"
          />
        </div>
      )}

      {/* Shared: SaaS, E-commerce */}
      {(subtype === 'TO_saas' || subtype === 'TO_ecommerce') && (
        <div className="field">
          <label>Pricing Model</label>
          <div className="flex flex-column gap-2">
            {pricingModels.map(model => (
              <div key={model} className="flex align-items-center">
                <RadioButton
                  inputId={`pricing-${model}_${subtype}`}
                  name="pricingModel"
                  value={model}
                  checked={formState[`pricingModel_${subtype}`] === model}
                  onChange={(e) => handleRadio(`pricingModel_${subtype}`, e.value)}
                />
                <label htmlFor={`pricing-${model}_${subtype}`} className="ml-2">{model}</label>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* E-commerce Specific */}
      {subtype === 'TO_ecommerce' && (
        <>
          <div className="field">
            <label>Platform Used</label>
            <InputText
              value={formState[`ecommercePlatform_${subtype}`] || ''}
              onChange={(e) => setFormState(`ecommercePlatform_${subtype}`, e.target.value)}
              placeholder="e.g. Shopify, WooCommerce, Custom"
            />
          </div>
        </>
      )}

      {/* IT Services Specific */}
      {subtype === 'TO_itServices' && (
        <>
          <div className="field">
            <label>Services Offered</label>
            <InputText
              value={formState[`itServices_${subtype}`] || ''}
              onChange={(e) => setFormState(`itServices_${subtype}`, e.target.value)}
              placeholder="e.g. Networking, Support, Security"
            />
          </div>
          <div className="field">
            <label>Support Hours</label>
            <InputText
              value={formState[`supportHours_${subtype}`] || ''}
              onChange={(e) => setFormState(`supportHours_${subtype}`, e.target.value)}
              placeholder="e.g. 24/7, 9–5 Weekdays"
            />
          </div>
        </>
      )}
    </div>
  );
}